import React from "react";
import IndianFoodFilter from "./Heritage/IndianFoodFilter";

const Test = () => {
  return (
    <div>
      <IndianFoodFilter />
    </div>
  );
};

export default Test;
